import { cx } from '@mage-ui/styled-system/css';
import { section } from '@mage-ui/styled-system/recipes';
import { SectionHeadingTop } from './section-headings/SectionHeadingTop';

export const HighlightSection = ({
  heading,
  children,
  className,
  ...props
}) => {
  return (
    <section className={cx(section().root, className)} {...props}>
      <SectionHeadingTop data={heading} />
      {children}
    </section>
  );
};
